import { MissionData } from '../blocks/mission'
import template from './templates/RJS01.rbxl'
import thumbnail1 from './thumbnails/RJS01/Ball1.png'
import thumbnail2 from './thumbnails/RJS01/Ball2.png'
import thumbnail3 from './thumbnails/RJS01/RedBlock.png'
import thumbnail4 from './thumbnails/RJS01/YellowBlock.png'
import thumbnail5 from './thumbnails/RJS01/BlueBlock.png'
import thumbnail6 from './thumbnails/RJS01/Ball3.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①1つめのボール',
      thumbnail: thumbnail1,
    },
    {
      name: '②2つめのボール',
      thumbnail: thumbnail2,
    },
    {
      name: '③あかいゆか',
      thumbnail: thumbnail3,
    },
    {
      name: '④きいろいゆか',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤あおいゆか',
      thumbnail: thumbnail5,
    },
    {
      name: '⑥3つめのボール',
      thumbnail: thumbnail6,
    },
  ],
}

export default mission
